
import { createApp } from 'vue'
import App from './App.vue'
 

const app = createApp(App)


import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/index.css'
import router from './router/index'

import Axios from './plugins/Axios'



// const DOMAIN_NAME = 'http://lo.oldageweb.cn/';
// const BASE_URL = DOMAIN_NAME + 'tm_website_admin/';

const DOMAIN_NAME = 'http://shadf.org.cn/';
const BASE_URL = DOMAIN_NAME + 'tm_website_admin/';

Axios.defaults.baseURL = BASE_URL;
app.config.globalProperties.$http = Axios;
app.config.globalProperties.$baseURL = BASE_URL;
app.config.globalProperties.$domainNAME = DOMAIN_NAME;

app.use(ElementPlus)
app.use(router)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}


app.mount('#app')

 